import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import QuantityCounterContainer from '../QuantityCounterContainer';
import QuantityBoxSkeleton from '../../QuantityBox/QuantityBoxSkeleton';

const QuantityCounterSkeleton = ({ ContainerElement }) => (
  <ContainerElement>
    <Box mr={2}>
      <QuantityBoxSkeleton />
    </Box>
    <Box mr={2}>
      <QuantityBoxSkeleton />
    </Box>
    <Box mt={3.5}>
      <QuantityBoxSkeleton showLabel={false} />
    </Box>
  </ContainerElement>
);

QuantityCounterSkeleton.propTypes = {
  ContainerElement: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.string]),
};

QuantityCounterSkeleton.defaultProps = {
  ContainerElement: QuantityCounterContainer,
};

export default QuantityCounterSkeleton;
